import React, { useContext, useEffect, useState } from 'react'
import { type FormValues } from '@s4l/ds'
import { ListOfPriceDistribution } from '@s4l/stayforlong/property/ListOfPriceDistribution'
import { SearchFilters as SearchFiltersModel } from '@s4l/stayforlong/property/SearchFilters'
import { SearchFilters } from '@s4l/uikit'
import { useSelector } from 'react-redux'
import { getDistributionPriceRange, getIsFetching } from 'src/effects/Properties/selectors'
import { FiltersContext } from '../FiltersContainer/context'
import { useRouter } from 'next/router'
import { useKafkaEvent } from 'src/hooks/useKafkaEvent'
import { PAGES, SECTIONS } from 'src/hooks/useKafkaEvent/constants'

interface IFiltersProps {
  onSubmit?: (filters: FormValues) => void
}

const Filters = ({ onSubmit }: IFiltersProps) => {
  const distributionPriceRange = useSelector(getDistributionPriceRange)
  const isFetching = useSelector(getIsFetching)

  const { query } = useRouter()
  const hasExtendedFilters = query.ff?.includes('new_filters')

  const { filters, setFilters } = useContext(FiltersContext)
  const [isLoadingPriceDistribution, setIsLoadingPriceDistribution] = useState(true)

  const { sendEvent: sendFiltersBottomSheetClosed } = useKafkaEvent({
    page: PAGES.LIST,
    eventName: 'filters_bottom_sheet_closed',
  })

  const onBottomSheetClosed = () => {
    sendFiltersBottomSheetClosed({ section: SECTIONS.SEARCH_FILTERS })
  }

  function handleApplyFilters(newFilters: FormValues) {
    setFilters(prev => ({ ...prev, ...newFilters }))
  }

  function onSubmitInternal(newFilters: FormValues) {
    handleApplyFilters(newFilters)
    onSubmit?.(newFilters)
  }

  const filtersModel = SearchFiltersModel.fromPrimitives(filters)

  const listOfPriceDistributionModel =
    ListOfPriceDistribution.fromLegacyContext(distributionPriceRange)

  useEffect(() => {
    if (!isLoadingPriceDistribution) return

    setIsLoadingPriceDistribution(isFetching)
  }, [isFetching, isLoadingPriceDistribution])

  return (
    <SearchFilters
      isLoadingPriceDistribution={isLoadingPriceDistribution}
      onFilterChange={handleApplyFilters}
      onSubmit={onSubmitInternal}
      defaultFiltersJSON={filtersModel.toJSON()}
      listOfPriceDistributionJSON={listOfPriceDistributionModel.toJSON()}
      showExtendedFilters={hasExtendedFilters}
      onBottomSheetClosed={onBottomSheetClosed}
    />
  )
}

export default Filters
